import "./utils";

if (document.querySelector(".swiper")) {
  import("./swipers/main").catch((error) => {
    console.error("Failed to load Swiper module:", error);
  });
}
if (document.querySelector(".backdrop")) {
  import("./popups/main").catch((error) => {
    console.error("Failed to load Popups module:", error);
  });
}
if (document.querySelector("#projects")) {
  import("./projects").catch((error) => {
    console.error("Failed to load Projects module:", error);
  });
}
if (document.querySelector("#single-projects")) {
  import("./project").catch((error) => {
    console.error("Failed to load Projects module:", error);
  });
}
if (document.querySelector("#home")) {
  import("./exploitation").catch((error) => {
    console.error("Failed to load Exploitation module:", error);
  });
}
if (document.querySelector("#documents")) {
  import("./documents").catch((error) => {
    console.error("Failed to load Documents module:", error);
  });
}
if (document.querySelector("#privacyContent .view-more")) {
  import("./privacy").catch((error) => {
    console.error("Failed to load Privacy module:", error);
  });
}

import "../css/main.scss";
import "./request/main";
// import "./readMore";
import "./headerScroll";
import "./openBuilding";

import "./scrollTop";
import "./gsap/index";
